import React, { useEffect, useState } from "react";
import styled from "styled-components";
import dayjs from "dayjs";
import { ChevronLeft, ChevronRight } from "../../styled/AllImages";
import { Box } from "../../styled/Elements";

const DateSelector = ({ selectedDates = [], setSelectedDates }) => {
  const [visibleDays, setVisibleDays] = useState(7);
  const [weekDates, setWeekDates] = useState([]);
  const [startDate, setStartDate] = useState(dayjs());

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 576) {
        setVisibleDays(3);
      } else if (width < 768) {
        setVisibleDays(4);
      } else if (width < 992) {
        setVisibleDays(5);
      } else {
        setVisibleDays(7);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    generateWeek(startDate);
  }, [startDate]);

  const generateWeek = (start) => {
    const days = [];
    for (let i = 0; i < 7; i++) {
      days.push(start.add(i, "day"));
    }
    setWeekDates(days);
  };

  const toggleDate = (date) => {
    const formatted = date.format("YYYY-MM-DD");
    if (selectedDates.includes(formatted)) {
      setSelectedDates(selectedDates.filter((d) => d !== formatted));
    } else {
      setSelectedDates([...selectedDates, formatted]);
    }
  };

  return (
    <DateWrapper>
      <NavButton onClick={() => setStartDate(startDate.subtract(7, "day"))} type="button">
        <ChevronLeft />
      </NavButton>

      <DatesContainer visibleDays={visibleDays}>
        {weekDates.map((date) => {
          const fullDate = date.format("YYYY-MM-DD");
          const active = selectedDates.includes(fullDate)
          return (
            <DateBox key={fullDate} onClick={() => toggleDate(date)} active={active}>
              <Box className="d-flex flex-column">
                <span className="day">{date.format("ddd")}</span>
                <span className="date">{date.format("DD")}</span>
                <span className="month">{date.format("MMM")}</span>
              </Box>
            </DateBox>
          );
        })}
      </DatesContainer>

      <NavButton onClick={() => setStartDate(startDate.add(7, "day"))} type="button">
        <ChevronRight />
      </NavButton>
    </DateWrapper>
  );
};


export default DateSelector;

// Styled Components
const DateWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const DatesContainer = styled.div`
  /* display: flex;
  justify-content: center;
  gap: 10px;
  flex: 1;
  overflow-x: auto; */
  display: grid;
  grid-template-columns: ${({ visibleDays }) => `repeat(${visibleDays}, 1fr)`};
  gap: 10px;
  width: 100%;
`;

// const DateBox = styled.div`
//   text-align: center;
//   border: ${({ active }) =>
//     active
//       ? "1px solid var(--themeColorSecondary)"
//       : "1px solid var(--border)"};
//   min-width: 70px;
//   border-radius: 10px;
//   cursor: pointer;
//   background-color: ${({ active }) =>
//     active ? "var(--themeColorSecondary)" : "#fff"};
//   color: ${({ active }) => (active ? "#fff" : "#000")};
//   font-weight: ${({ active }) => (active ? "bold" : "normal")};
//   transition: all 0.3s ease;

//   .day {
//     font-size: 16px;
//     border-bottom: 1px solid var(--border);
//     background-color: var(--bg);
//     border-radius: 9px 9px 0 0;
//     padding-top: 6px;
//     color: ${({ active }) =>
//       active ? "var(--themeColorSecondary)" : "var(--black)"};
//   }
//   .date {
//     padding-top: 6px;
//     font-size: 18px;
//   }
//   .month {
//     font-size: 16px;
//     padding-bottom: 6px;
//   }
// `;

const DateBox = styled.div`
  text-align: center;
  border: ${({ active }) =>
    active
      ? "1px solid var(--themeColorSecondary)"
      : "1px solid var(--border)"};
  border-radius: 10px;
  cursor: pointer;
  background-color: ${({ active }) =>
    active ? "var(--themeColorSecondary)" : "#fff"};
  color: ${({ active }) => (active ? "#fff" : "var(--text)")};
  font-weight: ${({ active }) => (active ? "bold" : "normal")};
  transition: all 0.3s ease;
  width: 100%; /* make it fit the grid cell */
  overflow: hidden;

  .day {
    font-size: 16px;
    border-bottom: 1px solid var(--border);
    background-color: var(--bg);
    border-radius: 9px 9px 0 0;
    padding-top: 6px;
    color: ${({ active }) =>
      active ? "var(--themeColorSecondary)" : "var(--text)"};
  }

  .date {
    padding-top: 6px;
    font-size: 18px;
  }

  .month {
    font-size: 16px;
    padding-bottom: 6px;
  }
`;


const NavButton = styled.button`
  background: none;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  border: 1px solid var(--border);
  padding: .3rem .8rem;
  border-radius: 8px;
`;
